export const ru = {
    archive: 'Весь архив',
    load: 'Показать еще'
};
